import React, {useRef, useState} from 'react';
import useUserStore from "../../store/userStore";
import './userMenu.css';
import useOutsideAlerter from "../../hooks/useOutsideAlerter";
import {Link} from "react-router-dom";

const UserMenu = () => {

    const {logOut,fio,login} = useUserStore()
    const [isOpenDropdown,setIsOpenDropdown] = useState<boolean>(false)
    const userMenuRef = useRef<HTMLDivElement>(null);
    useOutsideAlerter(userMenuRef,()=>{
        setIsOpenDropdown(false);
    })

    const toggleDropDown = () => {
      setIsOpenDropdown(!isOpenDropdown);
    }

    const logOutLocal = () => {
        logOut();
    }

    return (
        <div ref={userMenuRef} className={"user-menu btn-group dropstart"}>
            <button className={"btn btn-outline-light dropdown-toggle user-menu__btn"} onClick={()=>toggleDropDown()}>
                <i className="bi bi-person-circle me-1"></i><span className={"login__text"}>{fio}</span>
            </button>
            <ul className={`user-menu__dropdown dropdown-menu ${isOpenDropdown ? "show" : ''}`}>
                <li><h6 className="dropdown-header">{login}</h6></li>
                <li>
                    <Link to={'cart'} className="dropdown-item">
                        <i className="bi bi-basket-fill me-1"></i>
                        Корзина
                    </Link>
                </li>
                <li>
                    <Link to={'favourite'} className="dropdown-item">
                        <i className="bi bi-star-fill me-1"></i>
                        Избранное
                    </Link>
                </li>
                <li>
                    <Link to={'history'} className="dropdown-item">
                        <i className="bi bi-book me-1"></i>
                        История заказов
                    </Link>
                </li>
                <li>
                    <hr className="dropdown-divider"/>
                </li>
                <li onClick={()=>logOutLocal()}>
                    <div className="dropdown-item">
                        <i className="bi bi-box-arrow-left me-1"></i>
                        Выйти
                    </div>
                </li>
            </ul>
        </div>
    );
};

export default UserMenu;